export default __webpack_public_path__ + "static/schildkroete-74df4c1bbf931ccceecaf5394ad7b665.jpg";